var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCherry = function SvgCherry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cherry_svg__a)",
    d: "M125.723 104a3.18 3.18 0 0 1-3.246-2.628c-.021-.165-2.173-16.6-5.268-24.1-.634-1.539.223-2.263 1.915-2.839s3.579-.79 4.213.748c3.373 8.18 5.549 24.791 5.64 25.495a3.04 3.04 0 0 1-.738 2.255 3.06 3.06 0 0 1-2.129 1.045 4 4 0 0 1-.387.024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cherry_svg__b)",
    d: "M146.438 88.045c17.068-.95 43.239 13.1 45.251 43.33s-6.034 47.36-15.084 51.39c-7.9 3.521-8.045 8.062-24.134 10.077-16.992 2.129-18.1-1.008-22.122-1.008-6.034 0-5.028 4.259-14.212 4.164-12.939-.133-27.085-13.183-36.067-46.485-10.056-37.284 19.106-56.43 32.178-46.353 0 0 16.089-14.107 34.19-15.115"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cherry_svg__a",
    x1: 123.797,
    x2: 114.755,
    y1: 104.122,
    y2: 76.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cherry_svg__b",
    x1: 137.964,
    x2: 133.257,
    y1: 192.004,
    y2: 92.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgCherry;